import { apiSlice } from "app/api/apiSlice"

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUsers: builder.query({
            query: () => '/user',
            keepUnusedDataFor: 3600,
        })
    })
})

export const {
    useGetUsersQuery
} = usersApiSlice 